import { fieldByIdOrName } from './helpers/form';

const validateField = (fieldIdentifier, onChange = () => {}) => {
  // Variables
  var $fieldInput = fieldByIdOrName(fieldIdentifier);
  const fieldGroupIDName = (fieldIdentifier.startsWith('#') ? '' : '#') + fieldIdentifier + "-input-group";
  var $fieldInputGroup = $(fieldGroupIDName);
  
  // Validate on change
  $fieldInput.on("change", function () {
    onChange($fieldInput);
    $fieldInputGroup.trigger("validate");
  });
  
  // Custom validation event
  $fieldInputGroup.on("validate", function () {
    $fieldInputGroup.setValidityClass($fieldInput.getValidity());
  });

  return $fieldInput;
};

export { validateField };
